import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { BillingPlan, BillingPlanWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateBillingPlan(): UseMutationResult<
  AxiosResponse<BillingPlan>,
  AxiosError<ErrorMessage>,
  BillingPlanWrite
> {
  const queryClient = useQueryClient();

  const updateBillingPlan = useCallback((payload: BillingPlanWrite): Promise<AxiosResponse<BillingPlan>> => {
    return client.put(`billing-plans/${payload?.billingPlanId}/`, payload);
  }, []);

  return useMutation(updateBillingPlan, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['packages'],
      });
      queryClient.invalidateQueries({
        queryKey: ['billingPlans'],
      });
    },
  });
}
